'use client';
import { jsxs as t, jsx as e, Fragment as p } from "react/jsx-runtime";
import * as a from "react";
import { useRef as j, useImperativeHandle as D } from "react";
import { Icon as E } from "@tameeni/icons";
import z from "react-countdown";
import B from "react-otp-input";
import { Button as L } from "../button/button.js";
import { Skeleton as r } from "../skeleton/skeleton.js";
import F from "./otp-input-variants.js";
const H = a.forwardRef(
  (i, N) => {
    const {
      receivedOn: v,
      isInvalid: m,
      milliseconds: o,
      onResend: I,
      isLoading: u,
      countdownText: b,
      expiryText: g,
      incorrectOtpMessage: T,
      resendButtonLabel: w,
      locale: C,
      numInputs: d = 4
    } = i, [O, S] = a.useState(
      Date.now() + o
    ), [x, f] = a.useState(!1), l = j(null), { input: n, inputContainer: h } = F(), y = a.useCallback(() => {
      f(!1);
    }, []), R = a.useCallback(() => {
      f(!0);
    }, []);
    D(
      N,
      () => ({
        resetTimer: (s) => {
          var c;
          S(
            Date.now() + (s || o)
          ), (c = l == null ? void 0 : l.current) == null || c.start();
        }
      }),
      [o]
    );
    const k = ({ formatted: s, completed: c }) => c ? /* @__PURE__ */ t("div", { className: "flex mt-2 justify-between items-center", children: [
      /* @__PURE__ */ e("span", { className: "text-s3 text-red-500", children: g }),
      /* @__PURE__ */ e(L, { variant: "text", size: "loose", onClick: I, children: w })
    ] }) : /* @__PURE__ */ e("div", { className: "flex mt-2 gap-1 items-center", children: /* @__PURE__ */ t("span", { className: "text-b3 text-slate-500", children: [
      b,
      " ",
      /* @__PURE__ */ t("span", { className: "text-s3 text-slate-500", children: [
        s.minutes,
        ":",
        s.seconds
      ] })
    ] }) });
    return /* @__PURE__ */ t("div", { className: "flex flex-col w-fit", children: [
      /* @__PURE__ */ e("h1", { className: "text-t2 mb-1", children: C === "ar" ? /* @__PURE__ */ t(p, { children: [
        "قم بإدخال ال ",
        d,
        " ارقام التي استقبلتها على"
      ] }) : /* @__PURE__ */ t(p, { children: [
        "Enter ",
        d,
        " digits you received on"
      ] }) }),
      /* @__PURE__ */ e("span", { className: "text-b3 mb-6 text-slate-600", children: u ? /* @__PURE__ */ e(r, { className: "h-2 w-20" }) : v }),
      u ? /* @__PURE__ */ t("div", { className: h({ className: "flex" }), children: [
        /* @__PURE__ */ e(r, { className: n() }),
        /* @__PURE__ */ e(r, { className: n() }),
        /* @__PURE__ */ e(r, { className: n() }),
        /* @__PURE__ */ e(r, { className: n() })
      ] }) : /* @__PURE__ */ t(p, { children: [
        /* @__PURE__ */ e("span", { dir: "ltr", children: /* @__PURE__ */ e(
          B,
          {
            placeholder: "----",
            inputStyle: n({
              ...i,
              isInvalid: x || m
            }),
            containerStyle: h({
              ...i,
              isInvalid: x || m
            }),
            numInputs: d,
            ...i,
            renderInput: (s) => /* @__PURE__ */ e("input", { ...s })
          }
        ) }),
        m && /* @__PURE__ */ t("div", { className: "flex mt-2 gap-1 items-center", children: [
          /* @__PURE__ */ e(E, { name: "Delete", className: "size-4 text-red" }),
          /* @__PURE__ */ e("span", { className: "text-red text-s3", children: T })
        ] }),
        /* @__PURE__ */ e(
          z,
          {
            ref: l,
            date: O,
            onStart: y,
            onComplete: R,
            renderer: k
          }
        )
      ] })
    ] });
  }
);
H.displayName = "OtpInput";
export {
  H as OtpInput
};
